import { CrossHatchStatIcon } from "./SummaryStatIcons";
import { SummaryStatVariant } from "../SummaryStatCard";

export const totalAcres: SummaryStatVariant = {
  icon: <CrossHatchStatIcon />,
  label: "Total Acres",
};
